/* eslint-disable */
import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import { isMobile, isTablet } from "react-device-detect";

function CblProduct() {
  const [list, setlist] = useState([]);
  const [categories, setCategories] = useState([]);
  const [query, setquery] = useState("");
  const [active, setactive] = useState("disable");
  const [catquery, setcatquery] = useState("All Products");
  const filterSectionByListElm = document.querySelector(
    ".filter-by-section-list"
  );
  //const optionWrapperOverlayElm = document.querySelector('.optionWrapperOverlay');
  const hash =
    document.URL.split("#").length > 1 ? document.URL.split("#")[1] : query;

  useEffect(() => {
    function fetchAPI() {
      //const requestURL = "<?php echo plugins_url(); ?>/xpansiv/assets/cbl-product.json";
      //const requestURL = "https://spreadsheets.google.com/feeds/list/1Y9EUaL0PE7u-1AbBoCTaVyMa7oqiZCcEPGXcXES8eLQ/1/public/full?alt=json";
      const requestURL =
        "https://sheets.googleapis.com/v4/spreadsheets/1Y9EUaL0PE7u-1AbBoCTaVyMa7oqiZCcEPGXcXES8eLQ/values/sheet1?alt=json&key=AIzaSyA_U3h3W_rR5Yr-US7C-yTzx02evV9ntk4";

      const response = fetch(requestURL)
        .then(function (response) {
          console.log(response);
          response.json().then(function (data) {
            const { values } = data;

            //remove first row that contains headers
            values.shift();

            //set list data
            console.log(values);
            setlist(values);

            //set categories
            console.log("trying to set categories");
            var sortedCategories = values
              .map((item) => item[0])
              .filter((v, i, a) => a.indexOf(v) === i)
              .sort(function (a, b) {
                return a > b;
              });
            // values.forEach(function (category) {
            //     sortedCategories["'" + category[0] + "'"] = category[0];
            // });

            setCategories(sortedCategories);
            console.log("done setting categories");

            console.log("Sorted categories:", sortedCategories);
            console.log("categories:", categories);

            //set active category based on URL hash
            if (unescape(hash).length > 0) {
              setcatquery(unescape(hash));
            }
          });
        })
        .catch(function (err) {
          console.log("Fetch Error: ", err);
        });

      // axios.get(requestURL)
      //     .then(res => {
      //         console.log(res);
      //         const responseJSON = res;
      //         // const {values} = responseJSON;
      //         const values = res.data.values;
      //         const majorDimension = res.data.majorDimension;
      //         const range = res.data.range;
      //         values.shift();
      //         setlist(values);

      //         if(unescape(hash).length>0) {
      //             setcatquery(unescape(hash));
      //         }
      //     })
      //     .catch(console.log)
    }
    fetchAPI();
  }, []);

  // function getUniqueItemList(currentList){
  //     return [...new Set(currentList.map(item => item["Product Code"]))]
  // }

  // function getItemFilter(value){
  //     for(let i = 0 ; i < list.length;i++){
  //         console.log(list[i]);
  //         if(list[i]["Product Code"] === value ){
  //            return list[i]["Product Name"];
  //         }
  //     }
  //     return '-';
  // }

  function search(rows) {
    // need to check if ppl choose specific Market, make sure the list only show that market.
    let filtered = rows;
    //console.log("catquery", catquery);
    //console.log("filtered", filtered);
    if (catquery != "" && catquery != "All Products") {
      filtered = rows.filter((row) => {
        return (
          row[0].toString().toLowerCase().indexOf(catquery.toLowerCase()) > -1
        );
      });
    }

    let searched = filtered.filter(
      (row) =>
        row[0].toString().toLowerCase().indexOf(query.toLowerCase()) > -1 ||
        row[1].toString().toLowerCase().indexOf(query.toLowerCase()) > -1 ||
        row[2].toString().toLowerCase().indexOf(query.toLowerCase()) > -1 ||
        row[4].toString().toLowerCase().indexOf(query.toLowerCase()) > -1
    );

    //console.log('searched', searched);
    return searched;
  }

  const handleOpenSelect = () => {
    if (filterSectionByListElm.style.display != "none") {
      filterSectionByListElm.style.display = "none";
      //optionWrapperOverlayElm.style.display = 'none'
    } else {
      filterSectionByListElm.style.display = "block";
      //optionWrapperOverlayElm.style.display = 'block'
    }
  };

  const handleOverlay = (e) => {
    const currentValue = e.target.value;

    setTimeout(() => {
      const categoryItemListElm = document.querySelectorAll(
        ".category-item-list"
      );

      for (let i = 0; i < categoryItemListElm.length; i++) {
        if (categoryItemListElm[i].value.toString() === currentValue) {
          categoryItemListElm[i].classList.add("selectionOptionbtnSelected");
        }
      }

      if (filterSectionByListElm.style.display != "none") {
        filterSectionByListElm.style.display = "none";
        //optionWrapperOverlayElm.style.display = 'none'
      } else {
        filterSectionByListElm.style.display = "block";
        //optionWrapperOverlayElm.style.display = 'block'
      }
    }, 50);
  };

  const handleToggle = (e) => {
    const itemListElm = e.target.closest(
      ".plm-item-detail-wrapper"
    ).nextSibling;

    if (itemListElm) {
      if (itemListElm.style.display === "none") {
        itemListElm.style.display = "block";
        e.target
          .closest(".plm-item-detail-wrapper")
          .querySelector(".cbl-mobile-item-detail-icon").innerHTML = "-";
      } else {
        itemListElm.style.display = "none";
        e.target
          .closest(".plm-item-detail-wrapper")
          .querySelector(".cbl-mobile-item-detail-icon").innerHTML = "+";
      }
    }
  };

  if (isMobile && !isTablet) {
    return (
      <div>
        <h1 className="sub-title">PRODUCTS</h1>
        <div className="product-search-section">
          <div className="col">
            <div className="selectiveOption">
              <div className="selectiveOption-inner">
                <div
                  onClick={handleOpenSelect}
                  className="product-search-category"
                >
                  {catquery && catquery.length > 0 ? catquery : "All Products"}
                </div>
              </div>

              <div className="rt-tpg-container">
                <div className="filter-by-section-text"></div>
                <div
                  className="rt-tpg-isotope-buttons filter-button-group option-set filter-by-section-list __xps-select-option-wrapper"
                  style={{ display: "none" }}
                >
                  <div className="__xps-select-option-inner">
                    <button
                      key={uuidv4()}
                      className="category-item-list-allocate"
                      value={""}
                      onClick={(e) => {
                        setcatquery(e.target.value);
                        setquery("");
                        handleOverlay(e);
                      }}
                    >
                      All Products
                    </button>

                    {categories.map((item, key) => {
                      // console.log("Item: ", item);
                      return (
                        <button
                          key={uuidv4()}
                          className="category-item-list"
                          value={item}
                          onClick={(e) => {
                            setcatquery(e.target.value);
                            setquery("");
                            handleOverlay(e);
                          }}
                        >
                          {item}
                        </button>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col">
            <div className="filter-list">
              <input
                placeholder={"Filter " + catquery}
                className="__xsv_filter-search"
                value={query}
                onChange={(e) => {
                  setquery(e.target.value);
                }}
              />
            </div>
          </div>
        </div>

        <div className="product-list-main">
          <div className="plm-item-title">
            <label>Product Code</label>
          </div>

          {list.length > 0 &&
            search(list).map((item, id) => {
              return (
                <div className="plm-item-wrapper" key={uuidv4()}>
                  <div
                    className="plm-item-detail-wrapper"
                    onClick={(e) => handleToggle(e)}
                  >
                    <div className="cbl-mobile-item-detail-name">{item[4]}</div>
                    <div className="cbl-mobile-item-detail-name cbl-mobile-item-detail-icon font-weight-bold">
                      +
                    </div>
                  </div>
                  <div
                    className="plm-item-detail-outer-wrapper"
                    style={{ display: "none" }}
                  >
                    <div className="cbl-item-detail-wrapper">
                      <div className="cbl-mobile-item-title-name ">
                        Product Name:
                      </div>
                      <div className="cbl-mobile-item-detail-name text-bid ">
                        <a
                          href={
                            "/cbl-product/?prod_name=" +
                            item[2] +
                            "&prod_description=" +
                            item[3] +
                            "&prod_code=" +
                            item[4] +
                            "&prod_clearingsettlement=" +
                            item[5] +
                            "&prod_lotsize=" +
                            item[6] +
                            "&prod_currency=" +
                            item[7] +
                            "&prod_minimumpricefluctuation=" +
                            item[8] +
                            "&prod_registry=" +
                            item[9] +
                            "&prod_market=" +
                            item[10] +
                            "&prod_tradinghours=" +
                            item[11]
                          }
                        >
                          {item[2]}
                        </a>
                      </div>
                    </div>
                    <div className="cbl-item-detail-wrapper">
                      <div className="cbl-mobile-item-title-name ">
                        Program/Standard:{" "}
                      </div>
                      <div className="cbl-mobile-item-detail-name">
                        {item[1]}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    );
  } else {
    return (
      <div>
        <h1 className="sub-title">PRODUCTS</h1>
        <div className="product-search-section row">
          <div className="col">
            <div className="selectiveOption">
              <div className="selectiveOption-inner">
                <div
                  onClick={handleOpenSelect}
                  className="product-search-category"
                >
                  {catquery && catquery.length > 0 ? catquery : "All Products"}
                </div>
              </div>
              <div className="rt-tpg-container">
                <div className="filter-by-section-text"></div>
                <div
                  className="rt-tpg-isotope-buttons filter-button-group option-set filter-by-section-list __xps-select-option-wrapper"
                  style={{ display: "none" }}
                >
                  <div className="__xps-select-option-inner">
                    <button
                      key={uuidv4()}
                      className="category-item-list"
                      value={""}
                      onClick={(e) => {
                        setcatquery(e.target.value);
                        setquery("");
                        handleOverlay(e);
                      }}
                    >
                      All Products
                    </button>

                    {categories.map((item, key) => {
                      // console.log("Item: ", item);
                      return (
                        <button
                          key={uuidv4()}
                          className="category-item-list"
                          value={item}
                          onClick={(e) => {
                            setcatquery(e.target.value);
                            setquery("");
                            handleOverlay(e);
                          }}
                        >
                          {item}
                        </button>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col">
            <div className="filter-list">
              <input
                placeholder={
                  "Search " +
                  (catquery && catquery.length > 0 ? catquery : "All Products")
                }
                className="__xsv_filter-search"
                value={query}
                onChange={(e) => {
                  setquery(e.target.value);
                }}
              />
            </div>
          </div>
        </div>

        <div className="table table-light pb-4">
          <div className="table--columns">
            <div className="c1">Product Code</div>
            <div className="c2">Product Name</div>
            <div>Program/Standard</div>
          </div>
          {search(list).map((item, id) => {
            // console.log(item)
            return (
              <div className="table--row" key={id}>
                <div className="c1" scope="row">
                  {item[4]}
                </div>
                <div className="c2">
                  <a
                    href={
                      "/cbl-product/?prod_name=" +
                      item[2] +
                      "&prod_description=" +
                      item[3] +
                      "&prod_code=" +
                      item[4] +
                      "&prod_clearingsettlement=" +
                      item[5] +
                      "&prod_lotsize=" +
                      item[6] +
                      "&prod_currency=" +
                      item[7] +
                      "&prod_minimumpricefluctuation=" +
                      item[8] +
                      "&prod_registry=" +
                      item[9] +
                      "&prod_market=" +
                      item[10] +
                      "&prod_tradinghours=" +
                      item[11]
                    }
                  >
                    {item[2]}
                  </a>
                </div>
                <div>{item[1]}</div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default CblProduct;
/* eslint-enable */



// WEBPACK FOOTER //
// ./scripts/components/CblProduct.js